function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-responsive-modal/~/@babel/runtime/helpers/interopRequireDefault.js
 ** module id = 1047
 ** module chunks = 0
 **/